enum SortType {
  ON = 'ON',
  OFF = 'OFF',
  IMMOBILIZED = 'IMMOBILIZED',
}

export default SortType;
